import React, {useEffect, useState, useRef} from 'react';
import {connect} from 'react-redux';
import '../UserList/UserList.scss';
import ItemList from '../../../common/components/ItemList/ItemList';
import ListPaginator from '../../../common/components/ListPaginator/ListPaginator';
import PropTypes from 'prop-types';
import icSearch from '../../../images/ic_search.png';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import {useHistory} from 'react-router-dom';
import actions from '../../../redux/actions';
import Loading from '../../../common/components/Loading/Loading';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import Modal from '../../../common/components/Modal/Modal';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const AdminList = (props) => {
    const {
        name,
        columnDataAdmin,
        deleteAdmin,
        getUsers,
        users,
        getUsersState,
        adminListConfig,
        setListConfig,
        switchOfUser,
        resetPassEmail,
        userInfo,
        cleanListConfig,
        showSidebar,
    } = props;

    const [columnName, setColumnName] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalText, setModalText] = useState('');
    const [modalButtonAction, setModalButtonAction] = useState(null);

    const history = useHistory();

    const [search, setSearch] = useState('');

    const [currentPage, setCurrentPage] = useState(-1);
    const pageQuantity = Math.ceil(users?.total/adminListConfig.size);

    const pushPage = (name) => {
        history.push(name);
    };

    const isInitialMount = useRef(true);

    useEffect(()=>{
        if ( !isInitialMount.current ) {
            setListConfig( {
                list: 'adminListConfig',
                config: {page: currentPage},
            } );
            getUsers();
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect( ()=>{
        if ( currentPage > pageQuantity ) setCurrentPage( pageQuantity );
        // eslint-disable-next-line
    }, [users] );

    useEffect(() => {
        switchOfUser('Administradores');
        cleanListConfig('adminListConfig');
        setCurrentPage( adminListConfig?.page ?? -1 );
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setColumnName(columnDataAdmin);
    }, [columnDataAdmin]);

    const sortList = (param)=>{
        setListConfig( {
            list: 'adminListConfig',
            config: {orderBy: param},
        } );
        getUsers();
    };

    const handleSearch = () => {
        setListConfig( {
            list: 'adminListConfig',
            config: {search: search, page: 1},
        } );
        getUsers();
    };

    const handleClickDelete = (admin) => {
        deleteAdmin(admin.id);
        handleClose();
    };

    const handleDelete = (data) => {
        if (data.id === userInfo.id) {
            setModalButtonAction(() => () => handleClose());
            setModalText('¡NO PUEDE ELIMINARSE A USTED MISMO!');
            setShowModal(true);
        } else {
            setModalButtonAction(() => () => handleClickDelete(data));
            setModalText('¿SEGURO QUE DESEA ELIMINAR ESTE ADMINISTRADOR?');
            setShowModal(true);
        }
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleResetPass = (data) => {
        setModalButtonAction(() => () => handleClickResetPass(data));
        setModalText('¿SEGURO QUE DESEA RESTABLECER LA CONTRASEÑA DE ESTE ADMINISTRADOR?');
        setShowModal(true);
    };

    const handleClickResetPass = (data) => {
        if (data.email === userInfo.email) {
            handleClose();
            history.push('/change_password');
        } else {
            resetPassEmail( {email: data.email} );
            handleClose();
        }
    };

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">ADMINISTRADORES</p>
                        <hr id="id-hr"/>
                    </div>
                    <div className="ul-div-header-container">
                        <Ebutton classNameButton="ul-btn" onClick={()=>pushPage('add')} text="NUEVO ADMINISTRADOR" />
                        <hr className={'ul-hr'}/>
                        <div className="ul-div-searchbar ">
                            <input
                                placeholder="Buscar administrador"
                                value={search}
                                onChange={(e) => setSearch(e.target.value.replace(/[^@\w\s.]/gi, ''))}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        handleSearch();
                                    }
                                }}
                            />
                            <button onClick={() => handleSearch()}><img src={icSearch} alt={'search'}/></button>
                        </div>

                    </div>
                </div>

                <div className="ul-div-sect-table">
                    { getUsersState?.success?
                        <table className="ul-div-table">
                            <ItemList
                                type="lender-header"
                                data={columnName}
                                isAdminList={true}
                                sortList={sortList}
                                sortParam={adminListConfig.orderBy}
                            />
                            <tbody>
                            {
                                users?.results?.length <= 0 ?
                                <tr><td colSpan={100} ><CustomAlert text='administradores' /></td></tr> :
                                users?.results && users?.results.map((item, index) =>
                                    <ItemList
                                        key={index}
                                        type="lender-data"
                                        data={item}
                                        isAdminList={true}
                                        handleDelete={handleDelete}
                                        handleResetPass={handleResetPass}
                                    />,
                                )
                            }
                            </tbody>
                        </table> :
                    getUsersState?.loading?<Loading className="ul-div-sect-table" />:
                        <CustomAlert text={'administradores' || String(getUsersState?.error)} severity='error' />
                    }
                </div>

                <div className="ul-div-bottom">
                    <ListPaginator pageQuantity={pageQuantity} currentPage={adminListConfig.page} setCurrentPage={setCurrentPage} initInOne={true}
                    />

                </div>
            </div>
            {showModal && (
                <Modal
                    showModal={showModal}
                    handleClose={handleClose}
                    handleClick={modalButtonAction}
                    modalText={modalText}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    columnDataAdmin: state.home.columnDataAdmin,
    users: state.home.users,
    getUsersState: state.home.getUsersState,
    adminListConfig: state.home.adminListConfig,
    userInfo: state.login.userInfo,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    getUsers: () => dispatch(actions.home.getUsersRequest()),
    setListConfig: (body) => dispatch(actions.home.setListConfig(body)),
    deleteAdmin: (id) => dispatch(actions.home.deleteAdminRequest(id)),
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    cleanUsers: () => dispatch(actions.home.cleanUsers()),
    resetPassEmail: (body) => dispatch(actions.login.resetPassEmailRequest(body)),
    cleanListConfig: (list) => dispatch( actions.home.cleanListConfig(list) ),
});

AdminList.propTypes = {
    name: PropTypes.string,
    columnDataAdmin: PropTypes.object,
    getUsers: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminList);

